var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
    This file is generated with the "identicons" script.
    To update this output make changes to `scripts/svgr/identicon-icon-template.js
    */
import * as React from 'react';
import { IdenticonsCustomProperty, useColorMap, identiconComponentName } from '../common';
import { styled } from '../../styled';
export var IdenticonBoundaryProtocol = styled(function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    var colorMap = useColorMap({
        color: color,
    });
    var fills = {
        light: "var(".concat(IdenticonsCustomProperty.light, ", ").concat(colorMap.light, ")"),
        base: "var(".concat(IdenticonsCustomProperty.base, ", ").concat(colorMap.base, ")"),
        dark: "var(".concat(IdenticonsCustomProperty.dark, ", ").concat(colorMap.dark, ")"),
    };
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 38c0-3.307 2.693-6 6-6s6 2.69 6 6c0 3.307-2.693 6-6 6s-6-2.693-6-6zm4 0c0-1.102.898-2 2-2 1.102 0 2 .897 2 2 0 1.102-.898 2-2 2-1.102 0-2-.898-2-2z", fill: fills.dark }),
        React.createElement("path", { d: "M35.779 28H12.22A4.221 4.221 0 018 23.779V8.222A4.221 4.221 0 0112.222 4h23.557A4.221 4.221 0 0140 8.222v15.557A4.221 4.221 0 0135.779 28z", fill: fills.light }),
        React.createElement("path", { d: "M39.853 39.94H28.97a1.97 1.97 0 110-3.94h10.883a1.97 1.97 0 110 3.94zM18.853 39.94H7.97a1.97 1.97 0 110-3.94h10.883a1.97 1.97 0 110 3.94zM29.391 14.268h-11.08a1.365 1.365 0 01-.966-2.331L20.881 8.4a1.365 1.365 0 111.932 1.932L21.61 11.54h7.785a1.365 1.365 0 11-.003 2.73zM25.855 24.27a1.365 1.365 0 01-.966-2.332l1.207-1.206h-7.785a1.365 1.365 0 110-2.732h11.083a1.366 1.366 0 01.966 2.332L26.82 23.87c-.266.269-.616.4-.966.4z", fill: fills.dark })));
}, {
    name: identiconComponentName,
})({});
